export default __webpack_public_path__ + "static/media/wave-gulfblue-background.ea2de1df.png";